import * as React from "react"
const Left = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    {...props}
  >
    <path
      stroke="#202327"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity={0.6}
      strokeWidth={1.5}
      d="M8.75 10.5S5.25 7.922 5.25 7c0-.922 3.5-3.5 3.5-3.5"
    />
  </svg>
)
export default Left
